/* import __COLOCATED_TEMPLATE__ from './note.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();